import { TransformationInterface, FilterByAssetOption } from '../types';

const TRANSFORMATIONS_ASSETS_BASE_PATH = 'https://res.cloudinary.com/prod/image/upload/v1599135778/demo-pages/transformations/';

export const PREDEFINED_TRANSFORMATIONS: Array<TransformationInterface> = [
  {
    label: 'Cartoonify effect',
    key: 'e_cartoonify',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}e_cartoonify.jpg`,
    definition: { effect: 'cartoonify' },
  },
  {
    label: 'Grayscale effect',
    key: 'e_grayscale',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}e_grayscale.jpg`,
    definition: { effect: 'grayscale' },
  },
  {
    label: 'Border color',
    key: 'bo_5px_solid_red',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}bo_5px_solid_red.jpg`,
    definition: { border: '5px_solid_rgb:ff0000' },
  },
  {
    label: 'Text overlay',
    key: 'l_text:roboto_100:Text%20Overlay,co_rgb:ffffff',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}text.jpg`,
    definition: { color: '#ffffff', overlay: { font_family: 'roboto', font_size: 100, text: 'Text Overlay' } },
  },
  {
    label: 'Rounded corners',
    key: 'r_100',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}r_100.png`,
    definition: { radius: 100 },
  },
  {
    label: 'Rotate',
    key: 'a_90',
    image: `${TRANSFORMATIONS_ASSETS_BASE_PATH}a_90.jpg`,
    definition: { angle: 90 },
  },
];

export const MAX_FILES_DEBOUNCE_TIME = 1000;

export const COOKBOOK_URL = 'https://cloudinary.com/cookbook';

export const ASSET_TYPES: FilterByAssetOption[] = [
  { value: undefined, label: 'All (Default)' },
  { value: 'image', label: 'Images' },
  { value: 'raw', label: 'Files' },
  { value: 'video', label: 'Video' },
];

export const INLINE_CONTAINTER = '#widget_container';
